import { Height } from "@mui/icons-material";
import useLayoutConfigStore from "store/layout-config-store/useLayoutConfigStore";
import { Row, Col } from "v2/components/base/Flex/ui";
import { ViewPoint } from "v2/components/base/ResponsiveLayout/ui";

const RootLayout = ({
  SideBar,
  children,
}: {
  SideBar: React.ReactNode;
  children: React.ReactNode;
}) => {
  return (
    <Col type="cc" sx={{ maxWidth: "1200px", marginX: "auto" }} fullWidth fullHeight>
      {/* Mobile */}
      <MobileWrapper>
        <ContentSection children={children} />
      </MobileWrapper>
      {/* Desktop */}
      <DesktopWrapper>
        <Row fullWidth fullHeight sx={{ maxWidth: "1200px", overflowX: "hidden", gap: "84px" }}>
          <SideBarSection Sidebar={SideBar} />
          <ContentSection children={children} />
        </Row>
      </DesktopWrapper>
    </Col>
  );
};

const MobileWrapper = ({ children }: { children: React.ReactNode }) => {
  const { isShowFooter } = useLayoutConfigStore();
  return (
    <ViewPoint.Mobile>
      <Row
        sx={{
          background: `url("root-bg.png") no-repeat center center`,
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
        }}
        fullWidth
        fullHeight>
        <Row
          type="cc"
          sx={{
            padding: "0 16px",
            backdropFilter: "blur(40px)",
          }}
          fullWidth
          fullHeight>
          <Row
            type="cc"
            sx={{
              height: "100%",
            }}
            fullWidth
            fullHeight>
            {children}
          </Row>
        </Row>
      </Row>
    </ViewPoint.Mobile>
  );
};

const DesktopWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <ViewPoint.Desktop>
      <Row
        sx={{
          background: `url("/root-bg.png") no-repeat center center`,
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
        }}
        fullWidth
        fullHeight>
        <Row
          type="bs"
          sx={{
            padding: "24px 0 24px",
            gap: "60px",
            backdropFilter: "blur(40px)",
          }}
          fullWidth
          fullHeight>
          {children}
        </Row>
      </Row>
    </ViewPoint.Desktop>
  );
};

const SideBarSection = ({ Sidebar }: { Sidebar: React.ReactNode }) => {
  return (
    <Col section="sidebar" type="bs" fullHeight>
      {Sidebar}
    </Col>
  );
};

const ContentSection = ({ children }: { children: React.ReactNode }) => {
  return (
    <Col section="content" type="bs" sx={{ height: "100%" }} fullWidth fullHeight>
      {children}
    </Col>
  );
};

export default RootLayout;
